<template>
    <div v-if="showNotification" class="stock-notification">
    <h4>Stock Notification</h4>
    <ul>
      <li><strong>Out of Stock:</strong> {{ outOfStock }} items</li>
      <li><strong>Running Low:</strong> {{ runningLow }} items</li>
    </ul>
    <p>
        Consider reviewing inventory to address any potential stock outs before they occur.
    </p>
    <router-link to="/stock/outof_stock" class="btn btn-warning mt-3 ml-5">
        <i class="fa fa-list"></i> Click to View out of stock
        </router-link>
  </div>
  </template>
  
  <script>
  export default {
    props: {
      outOfStock: {
        type: Number,
        default: 0
      },
      runningLow: {
        type: Number,
        default: 0
      },
      showNotification: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  
  <style scoped>
  .stock-notification {
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f9f9f9;
    padding: 15px;
    margin: 15px 0;
    color: #333;
  }
  
  .stock-notification h4 {
    margin-top: 0;
    color: #d9534f;
  }
  
  .stock-notification ul {
    list-style-type: none;
    padding-left: 0;
  }
  
  .stock-notification li {
    margin: 5px 0;
  }
  
  .stock-notification p {
    margin-top: 10px;
    font-weight: bold;
  }
  </style>